import * as React from 'react';
import DriveItemSelectionIcon from '../../../containers/Selection/Toggler';
import { ListDisplayType } from '../../../containers/DriveItemList/constants';
import { ResolutionDisplayType, ThumbnailDescriptor } from '../../../utils/driveItem';
import {
	GridImageWrapper, RowImageWrapper, BlockSvgWrapper, RowSvgWrapper,
	RowBackgroundImage, GridBackgroundImage, MasonryImage, MasonryImageWrapper
} from './styles';
import Utils from '../../../utils';

interface ListItemThumbnailProps {
	selectionId?: number;
	thumbnailDescriptor: ThumbnailDescriptor;
	displayType: ListDisplayType;
	isActivated: boolean;
	hasSelectionIcon: boolean;
}

const favElement = (props: ListItemThumbnailProps) => {
	const { hasSelectionIcon, selectionId, displayType, thumbnailDescriptor } = props;
	const { isImage } = thumbnailDescriptor;

	return hasSelectionIcon && selectionId ? (
		<DriveItemSelectionIcon
			itemId={selectionId}
			displayMode={ResolutionDisplayType.Card}
			needBottomPadding={isImage && displayType === ListDisplayType.Masonry}
			isRowView={displayType === ListDisplayType.Row}
		/>
	) : null;
};

const getImageComponent = (displayType: ListDisplayType, isWrapper: boolean) => {
	switch (displayType) {
		case ListDisplayType.Row:
			return isWrapper ? RowImageWrapper : RowBackgroundImage;
		case ListDisplayType.Grid:
		case ListDisplayType.Coverflow:
			return isWrapper ? GridImageWrapper : GridBackgroundImage;
		case ListDisplayType.Masonry:
			return isWrapper ? MasonryImageWrapper : MasonryImage;
	}
};

const renderImage = (props: ListItemThumbnailProps) => {
	const { displayType, thumbnailDescriptor, isActivated } = props;
	const { src } = thumbnailDescriptor;

	const ImageWrapper = getImageComponent(displayType, true);
	const StyledImage = getImageComponent(displayType, false);

	return (
		<ImageWrapper isActivated={isActivated}>
			<StyledImage
				imgURL={displayType !== ListDisplayType.Masonry ? src : undefined}
				src={displayType === ListDisplayType.Masonry ? src : undefined}
			/>
			{favElement(props)}
		</ImageWrapper>
	);
};

const renderSvg = (props: ListItemThumbnailProps) => {
	const { displayType, thumbnailDescriptor } = props;
	const { src } = thumbnailDescriptor;
	const SvgWrapper = displayType !== ListDisplayType.Row ? BlockSvgWrapper : RowSvgWrapper;

	return (
		<SvgWrapper>
			{Utils.getSvgIcon(src)}
			{favElement(props)}
		</SvgWrapper>
	);
};

const ListItemThumbnail = (props: ListItemThumbnailProps) => {
	const { thumbnailDescriptor } = props;
	const { isImage } = thumbnailDescriptor;

	return isImage ? renderImage(props) : renderSvg(props);
};

export default ListItemThumbnail;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Thumbnail/index.tsx